module.exports = __webpack_public_path__ + "static/img/FITmenu06.fbdb2c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu06.png
// module id = AyBt
// module chunks = 1